import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getWPPostMedia } from 'services/wp';


const BlogContent = () => {
  const storeBlog = useSelector((state) => state.storeBlogs.value)
  const [featureImage, setFeatureImage] = useState();
  const [isImageLoading, setIsImageLoading] = useState(true);

  const { blogId } = useParams()
  const blog = storeBlog?.find(blog => blog.id === parseInt(blogId));

  const index = storeBlog.findIndex(blog => blog.id === parseInt(blogId));
  const previousBlogId = index === 0 ? storeBlog.length - 1 : index - 1;
  const nextBlogId = index === storeBlog.length - 1 ? 0 : index + 1;

  const blogTitle = blog?.title.rendered
  const rawBlogContent = blog?.content.rendered
  const blogContent = rawBlogContent ? rawBlogContent.replace(/\bMaryland\b\s*/gi, '') : null

  const backgroundLoading = (
    <div className='skeleton h-80 w-full rounded-none'></div>
  )

  useEffect(() => {

    const fetchPostMedia = async () => {
      try {
        const media = await getWPPostMedia(blog);
        setFeatureImage(media.media_details.sizes.full.source_url)
        setIsImageLoading(false)
      } catch (error) {
        console.error(`Error: ${error}`)
        setFeatureImage(null)
      } finally {
        setIsImageLoading(false)
      }
    }

    fetchPostMedia();

  }, [blog]);

  return (
    <div className='space-y-4 flex flex-col w-full max-w-3xl'>

      <div className='flex justify-center'>
        {
          isImageLoading ? backgroundLoading :
            featureImage === null ? null :
              <img src={featureImage} alt="Blog Featured" />
        }
      </div>


      <div className='text-4xl font-bold'>
        {blogTitle}
      </div>
      <div dangerouslySetInnerHTML={{ __html: blogContent || null }} />

      <div className='divider'></div>

      <div className='flex justify-between'>
        <div className='flex flex-col items-start'>
          <Link className='no-underline hover:no-underline flex items-center text-primary/55 text-xl font-bold' to={`/blog/${storeBlog[previousBlogId]?.id}`} ><p className='text-3xl mr-2'>«</p> Previous</Link>
          <div className='text-xl font-bold mr-12'>{storeBlog[previousBlogId]?.title.rendered || null}</div>
        </div>
        <div className='flex flex-col items-end'>
          <Link className='no-underline hover:no-underline flex items-center text-primary/55 text-xl font-bold' to={`/blog/${storeBlog[nextBlogId]?.id}`} >Next <p className='text-3xl ml-2'>»</p> </Link>
          <div className='text-xl text-right font-bold'>{storeBlog[nextBlogId]?.title.rendered || null}</div>
        </div>
      </div>

    </div>
  );
}

export default BlogContent;
